import React, { FC, ReactElement, useContext } from 'react';
import { NavLink } from 'react-router-dom';

import classes from './NavBar.module.scss';
import { Context } from '../../services/context';

export const NavBar: FC = (): ReactElement => {
  const { userData } = useContext(Context);

  return (
    <>
      <div className={classes.nav}>
        <NavLink
          activeClassName={classes.nav__link__active}
          className={classes.nav__link}
          to="/structure"
        >
          Орг. структура
        </NavLink>

        {userData?.role === 'Администратор' && (
          <NavLink
            activeClassName={classes.nav__link__active}
            className={classes.nav__link}
            to="/users"
          >
            Пользователи
          </NavLink>
        )}

        <NavLink
          activeClassName={classes.nav__link__active}
          className={classes.nav__link}
          to="/exception-words"
        >
          Слова исключения
        </NavLink>

        {/* {userData?.role === 'Администратор' ? (
          <NavLink
            activeClassName={classes.nav__link__active}
            className={classes.nav__link}
            to="/logs"
          >
            История действий
          </NavLink>
        ) : null}

        <NavLink
          activeClassName={classes.nav__link__active}
          className={classes.nav__link}
          to="/configuration"
        >
          Конфигурация полей
        </NavLink>
        <NavLink
          activeClassName={classes.nav__link__active}
          className={classes.nav__link}
          to="/thanks"
        >
          Спасибо
        </NavLink> */}
      </div>
    </>
  );
};
